import React, { Component, Fragment } from 'react'
import '../style.css'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import { Button, Glyphicon, Row, Col, FormControl } from 'react-bootstrap'
import ReactQuill from 'react-quill';
import { Typeahead } from 'react-bootstrap-typeahead'

import { deleteResourcePostDocument } from '../../resource-posts/reducers/manageResourcePosts'

import FileUploader from '../../../reuseable-components/file-uploading/FileUploader'
import FileWithOverlay from '../../../reuseable-components/file-uploading/FileWithOverlay'

class EditResourcePost extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: props.currentPost.name,
      text: props.currentPost.text,
      tags: props.currentPost.tags,
      documents: [],
    }
  }

  handleChange = (event) => this.setState({ [event.target.name]: event.target.value })

  removeDocument = (index) => {
    const { documents } = this.state
    this.setState({ documents: [...documents.slice(0, index), ...documents.slice(index + 1)]})
  }

  handleSave = () => {
    let { name, text, tags, documents } = {...this.state}
    let newTags = tags.filter(tag => !tag.hasOwnProperty('created_date'))
    if (newTags.length === 0) {
      newTags = null
    }
    if (newTags) {
      tags = tags.filter(tag => tag.hasOwnProperty('created_date'))
    }

    let post = new FormData()

    post.append("name", name)
    post.append("text", text)
    post.append('tags', JSON.stringify(tags.map(tag => tag.id)))

    if (newTags) {
      post.append('new_tags', JSON.stringify(newTags))
    }

    if (documents.length > 0) {
      documents.forEach((doc, index) => {
        post.append(`document${index}`, doc)
      })
    }

    this.props.handleUpdatePost(post)
  }

  render() {
    const { currentPost } = this.props
    let createdBy = `${currentPost.created_by.first_name} ${currentPost.created_by.last_name}`
    let createdById = currentPost.created_by.id

    let postedDate = currentPost.created_date.split("T")[0].split("-")
    let formatedDate = `${postedDate[1]}-${postedDate[2]}-${postedDate[0]}`

    return (
      <Fragment>
        <Col xsHidden smHidden mdHidden lg={1} xl={1}></Col>
        <Col xs={12} sm={12} md={12} lg={10} xl={10} id="post-content">
          <Row>
            <Col md={4}>
              <div>
                <Link to="/resource-posts">
                  <Button className="back-button">
                    <Glyphicon glyph="arrow-left" /> Back
                    </Button>
                  </Link>
                </div>
              </Col>
          <Col md={5}>
            <FormControl
              type='text'
              name='name'
              value={this.state.name}
              onChange={this.handleChange}
            />

            <Typeahead
              id="EditResourcePostTagsTypeahead"
              labelKey="name"
              allowNew
              multiple
              selected={this.state.tags}
              options={this.props.existingTags}
              onChange={(tags) => this.handleChange({target: {name: 'tags', value: tags}})}
              className="tag-form"
              placeholder="Input tags..."
            />
        </Col>
        <Col md={3}>
          <div>
            <div>Posted on: {formatedDate}</div>
            <div>Posted by: <span
              className={createdById === this.props.currentUser.pk ? "current-user" : null}
              >
              {createdBy}
            </span></div>
            <div>Views: {currentPost.views}</div>
          </div>
        </Col>
      </Row>
      <Row>
          <Col>
            <Button
              onClick={this.handleSave}
              className="back-button"
            >
              <Glyphicon glyph="ok" /> Save
            </Button>
            <Button
              onClick={this.props.toggleEditable}
              className="back-button"
            >
              <Glyphicon glyph="remove" /> Cancel
            </Button>
          </Col>
      </Row>
      <hr/>
      <ReactQuill
        value={this.state.text}
        theme="snow"
        placeholder="Input content..."
        onChange={(text) => this.handleChange({target: {name: 'text', value: text}})}

      />
      {currentPost.documents.length && currentPost.documents.length > 0 ?
        <Fragment>
          <br/>
          <label>Remove files</label>
          {currentPost.documents.map(doc => {
            return (
              <Fragment key={doc.id}>
                <br/>
                <FileWithOverlay
                  file={doc}
                  removeFile={() => this.props.deleteResourcePostDocument(doc.id)}
                />
              </Fragment>
            )
          })}
          <br/>
          <br/>
        </Fragment>
        :
        null
        }
        <br/>
        <center>
          <label>Add new files</label>
        </center>

        <FileUploader
          allowMultiple={true}
          filesForUpload={this.state.documents}
          handleFileDrop={(documents) => this.setState({ documents })}
          removeFile={this.removeDocument}
        />
      </Col>
    </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    existingTags: state.manageResourcePosts.tags,
  }
}

export default connect(mapStateToProps, { deleteResourcePostDocument })(EditResourcePost)



// WEBPACK FOOTER //
// ./src/routes/resource-posts_post/components/EditResourcePost.js